/**
 * NPS Service
 * Client-side service for NPS API interactions
 */

import apiService from './api.service'

const npsService = {
  /**
   * Check if user is eligible for NPS survey
   * @param {String} triggerType - Trigger type (first_login, offer_engagement, etc.)
   * @returns {Promise<Object>} { eligible: boolean, reason?: string, cooldownEndsAt?: Date }
   */
  checkEligibility: async (triggerType) => {
    try {
      const response = await apiService.post('/api/nps/check-eligibility', {
        triggerType,
      })
      return response
    } catch (error) {
      console.error('NPS checkEligibility error:', error)
      throw error
    }
  },

  /**
   * Submit NPS response
   * @param {Object} params - Response params
   * @param {String} params.triggerType - Trigger type
   * @param {Number} params.rating - Rating 0-5
   * @param {String} params.channel - Channel (IN_APP or EMAIL)
   * @param {String} [params.comment] - Optional comment
   * @param {String} [params.selectedReason] - Optional selected reason chip
   * @param {Object} [params.npsData] - Optional context data
   * @returns {Promise<Object>} { success: boolean, message: string, data: { category, submissionAction } }
   */
  submitResponse: async ({ triggerType, rating, channel = 'IN_APP', comment, selectedReason, npsData }) => {
    try {
      const response = await apiService.post('/api/nps/submit-response', {
        triggerType,
        rating,
        channel,
        comment: comment || null,
        selectedReason: selectedReason || null,
        npsData: npsData || null,
      })
      return response
    } catch (error) {
      console.error('NPS submitResponse error:', error)
      throw error
    }
  },

  /**
   * Skip NPS survey
   * @param {String} triggerType - Trigger type
   * @returns {Promise<Object>} { success: boolean, message: string }
   */
  skip: async (triggerType) => {
    try {
      const response = await apiService.post('/api/nps/skip', {
        triggerType,
      })
      return response
    } catch (error) {
      console.error('NPS skip error:', error)
      throw error
    }
  },
}

export default npsService
